import { graphql, PageProps } from "gatsby";
import { FC } from "react";
import Category from "src/components/Category";

import { CategoryPageContextType } from "./types";

const ThirdCategory: FC<
  PageProps<Gatsby.ThirdCategoryQuery> & CategoryPageContextType
> = ({
  pageContext: { pageIndex, upperCategories, subCategories, totalPages, pagePath },
  data: { datoCmsThirdCategory, allDatoCmsArticle },
}) => {
  if (!datoCmsThirdCategory || !allDatoCmsArticle) return null;

  return (
    <Category
      articles={[...allDatoCmsArticle.nodes]}
      category={datoCmsThirdCategory}
      categoryTitle={datoCmsThirdCategory.title!}
      pageIndex={pageIndex!}
      path={pagePath!}
      seo={datoCmsThirdCategory.seo!}
      subCategories={subCategories!}
      totalPages={totalPages!}
      upperCategories={upperCategories!}
    />
  );
};

export default ThirdCategory;

export const query = graphql`
  query ThirdCategory($id: String, $currentCategoryArticles: [String!], $skip: Int!, $limit: Int!) {
    datoCmsThirdCategory(id: { eq: $id }) {
      ...ThirdCategoryData
    }
    allDatoCmsArticle(
      filter: { id: { in: $currentCategoryArticles } }
      sort: { fields: meta___firstPublishedAt, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...DatoCmsArticleCard
      }
    }
  }
`;
